module.exports = __webpack_public_path__ + "img/banner_icon.ab76f7c0.jpg";